import { DatePipe } from '@angular/common';

export function formatDateFilter(date: string): string {
	const datePipe = new DatePipe('es-ES');
	return datePipe.transform(date, 'yyyy-MM-dd') || '';
}

export function findLastIndex(arr, predicate) {
	for (let i = arr.length - 1; i >= 0; i--) {
		if (predicate(arr[i], i)) {
			return i;
		}
	}
	return -1;
}
